var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("v-hover", {
    scopedSlots: _vm._u([
      {
        key: "default",
        fn: function ({ hover }) {
          return _c(
            "v-card",
            {
              class: { "card-hover": hover },
              attrs: {
                dark: _vm.dark,
                color: _vm.color,
                to: _vm.to,
                elevation: hover ? 12 : 2,
              },
            },
            [
              _c(
                "v-layout",
                [
                  _c(
                    "v-flex",
                    { staticClass: "pt-20", attrs: { sm4: "" } },
                    [
                      _c(
                        "v-btn",
                        {
                          staticClass: "btn-icon",
                          class: [hover ? "elevation-4" : "elevation-2"],
                          attrs: {
                            ripple: false,
                            fab: "",
                            large: "",
                            color: _vm._iconBgColor,
                          },
                        },
                        [
                          _c(
                            "v-icon",
                            { attrs: { color: _vm._iconColor, large: "" } },
                            [_vm._v(_vm._s(_vm.icon))]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-flex",
                    {
                      staticClass:
                        "d-flex align-center justify-center text-xs-center pr-3",
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "title font-weight-regular transition text-xs-left",
                        },
                        [_vm._v(_vm._s(_vm.title))]
                      ),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          )
        },
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }